import { render, staticRenderFns } from "./FieldTrainingForm.vue?vue&type=template&id=b35185ca"
import script from "./FieldTrainingForm.vue?vue&type=script&lang=js"
export * from "./FieldTrainingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports